import { DEFAULT_TIMEZONE, getUserTimezone } from '../hooks/useTimezone';

function getTimezone() {
  return getUserTimezone() || DEFAULT_TIMEZONE;
}

function normalizeInstant(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
    return new Date(`${s.replace(' ', 'T')}Z`);
  }
  return new Date(s);
}

function parts(value, timezone = getTimezone()) {
  const date = normalizeInstant(value);
  if (!date || Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: timezone,
    }).formatToParts(date);
  } catch {
    return null;
  }
}

export function getLocalDateKey(value, timezone = getTimezone()) {
  const p = parts(value, timezone);
  if (!p) return '';
  const pick = (type) => p.find((x) => x.type === type)?.value || '';
  return `${pick('year')}-${pick('month')}-${pick('day')}`;
}

export function isTodayInUserTimeZone(value, timezone = getTimezone()) {
  const key = getLocalDateKey(value, timezone);
  return key !== '' && key === getLocalDateKey(new Date(), timezone);
}

export function formatInstant(value, format = 'dateTime', timezone = getTimezone()) {
  const date = normalizeInstant(value);
  if (!date || Number.isNaN(date.getTime())) return '';
  const options =
    format === 'date'
      ? { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timezone }
      : format === 'time'
        ? { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timezone }
        : { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timezone };
  try {
    return new Intl.DateTimeFormat('ko-KR', options).format(date);
  } catch {
    return date.toLocaleString('ko-KR');
  }
}

export function formatPostTimestamp(value, timezone = getTimezone()) {
  if (!value) return '';
  return isTodayInUserTimeZone(value, timezone)
    ? formatInstant(value, 'time', timezone)
    : formatInstant(value, 'date', timezone);
}

export function formatDateSeparator(value, timezone = getTimezone()) {
  if (!value) return '';
  return isTodayInUserTimeZone(value, timezone) ? '오늘' : formatInstant(value, 'date', timezone);
}

export function formatDateOnly(value) {
  if (!value) return '';
  const [year, month, day] = String(value).slice(0, 10).split('-');
  if (!year || !month || !day) return String(value);
  return `${year}-${month}-${day}`;
}
